<template>
	<div>
		<modal ref="modal" @modal-fechou="() => modalFechou()">
			<div style="min-height: 400px">
				<button type="button" class="close" @click="$refs.modal.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>

				<!-- lista com dos despachos -->
				<div>
					<h4 class="modal-title">
						{{ _traducao('global', 'selecionarUmDiario').toUpperCase() }}
					</h4>

					<hr style="margin-top: 6px" />
                    <div class="row">
						<div class="col-xs-12">
							<p class="text-info">
								<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'mesmoMovimentacoesDb') }}
							</p>
						</div>
					</div>

                    <div class="row" style="margin-top: 4px">
						<div class="col-sm-12">
							<div
								ref="scrollDespacho"
								class="scroll"
								style="overflow-y: scroll"
							>
								<div class="table-responsive">
									<table class="table table-lista table-striped table-siga table-hover">
										<thead>
											<tr>
												<th class="text-center">{{ _traducao('global', 'origem') }}</th>
												<th class="text-center">{{ _traducao('global', 'volume') }}</th>
												<th class="text-center">{{ _traducao('global', 'combustivel') }}</th>
												<th class="text-center">{{ _traducao('global', 'tipoMovimentacao') }}</th>
											</tr>
										</thead>
										<tbody>
											<tr
												class="table-hover-tr"
												@click="clickMovimentacaoSelecionado(item)"
												v-for="(item, index) in lista" :key="index"
											>
												<td class="text-center">
													{{ item.origem }}
												</td>
												<td class="text-center">
													{{ item.volume }}
												</td>
												<td class="text-center">
													{{ item.combustivel }}
												</td>
                                                <td class="text-center">
													{{ item.tipo_movimentacao }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
export default {
	data() {
		return {
			lista: [],
			movimentacao: '',
		}
	},
	methods: {
		carregaDados(lista) {
			this.lista = lista
			this.$refs.modal.modalShow(80)
		},

		clickMovimentacaoSelecionado(movimentacao) {
			this.movimentacao = movimentacao
			this.$refs.modal.modalHide()
		},

		modalFechou() {
			if (this.movimentacao !== '') {
				this.$emit('selecionou-movimentacao', this.movimentacao)
			}
		},
	},
}
		
</script>